function extractColumnTable(table, lines, label, format, numberOfLevel, headerLabel)
{
    // on limite le nombre de colonne disponible
    lines.map(line => line.splice(numberOfLevel+1))
    const columnsValues = generateColumnsTable(numberOfLevel, format, headerLabel)
    table.push({
        label,
        columns: columnsValues,
        datas: lines
    })
}

/**
 * Génère la liste des colonnes
 * @param {*} maxLevel le nombre de niveau détecté
 * @param {*} format le callback de formatage
 * @param {*} headerString le string du header auquel sera concaténé le numéro
 * @returns
 */
const generateColumnsTable = (maxLevel, format, headerString) => {
    const columns = []
    for (let index = 0; index <= maxLevel; index++) {
        const label = index !== 0 ? `${headerString} ${index}` : ''
        const column = {
            label,
            format
        }
        columns.push(column)
    }

    return columns
}

export {
    extractColumnTable,
    generateColumnsTable
}
